import axios from "axios";
import { store } from "../redux/store";
import { getApiUrl } from "./apiUrls";
import { validateRefId } from "./helperFn";

const instance = axios.create();

// Request interceptor for API calls
instance.interceptors.request.use(
    async config => {
        //const token = getToken();
        const token = localStorage.getItem('token');
        config.headers = { 
            'Authorization': `Bearer ${token}`,
        }
        return config;
    },
    error => {
      Promise.reject(error)
});

const refreshAccessToken = async () => {
    try {
        const token = localStorage.getItem('token');

        if(!!token) {
            const res = await axios.get(getApiUrl('refreshToken'), {
                headers: {
                    "Authorization" : `Bearer ${token}`,
                }
            });

            //Set
            // cookies.set('token', res.data.jwtToken, { path: '/', expires: new Date(moment(decodedData.exp * 1000).format()) });
            // cookies.set('exp', moment(decodedData.exp * 1000).format() , { path: '/', expires: new Date(moment(decodedData.exp * 1000).format()) });
            localStorage.setItem('token', res.data.jwtToken);

            return res.data.jwtToken;
        }
    } catch (error) {
        const appSettings = store.getState()?.appSettings;
        const url = new URL(window.location.href);
        const rawRefId = url.searchParams.get("refId");
        const refId = validateRefId(rawRefId);

        localStorage.clear();
        window.location.href = appSettings?.returnUrl ? appSettings?.returnUrl : `/login${!!appSettings?.lang ? `?lang=${appSettings?.lang}` : ''}${refId ? `${appSettings?.lang ? "&" : "?"}refId=${refId}` : ''}`;
        return error;
    }
}

// Response interceptor for API calls
instance.interceptors.response.use((response) => {
    return response;
  }, async function (error) {
    const originalRequest = error.config;
    if (!!error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const access_token = await refreshAccessToken();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
      return instance(originalRequest);
    }
    return Promise.reject(error);
  });

export default instance;
